// PERSONAL LIBS
import { CronTask } from './crontask.class';
import { StoreCronStateEnum } from '@stores/cron/cron.enum';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';
import { IRefreshTokenChecker, UpdateManagerAuth } from '@shared/service/updateManager/update-manager-auth.service';

/**
 * TaskCheckRefreshTokenExpiration : check and / or refresh RefreshToken
 */
class TaskCheckRefreshTokenExpiration extends CronTask {
  defaultRunnerParam = {
    runImmediately: true,
    runOnce: false,
    frequency: 5000,
  };
  storeCronTaskEnum =
    StoreCronStateEnum.CHECK_REFRESH_TOKEN_REMAINING_TIME.toString();

  async task() {
    new UpdateManagerAuth.RefreshTokenChecker().exec<any, IRefreshTokenChecker>({
      silentRenew: false
    })
  }
}

/**
 * TaskCheckLiveness : liveness check
 */
class TaskCheckLiveness extends CronTask {
  defaultRunnerParam = {
    runImmediately: false,
    runOnce: false,
    frequency: 3000,
  };
  storeCronTaskEnum = StoreCronStateEnum.CHECK_LIVENESS.toString();

  async task() {
    new UpdateManagerAuth.AuthLiveness().exec();
  }
}

/**
 * TaskDisplayRemainingTime : display session remaining time (time given by the JWT token)
 */
class TaskDisplayAccessTokenRemainingTime extends CronTask {
  defaultRunnerParam = {
    runImmediately: false,
    runOnce: false,
    frequency: 1000,
  };
  storeCronTaskEnum =
    StoreCronStateEnum.DISPLAY_ACCESS_TOKEN_REMAINING_TIME.toString();

  async task() {
    await sessionManager.accessToken.refreshTokenData();
  }
}

class TaskDisplayRefreshTokenRemainingTime extends CronTask {
  defaultRunnerParam = {
    runImmediately: false,
    runOnce: false,
    frequency: 1000,
  };
  storeCronTaskEnum =
    StoreCronStateEnum.DISPLAY_REFRESH_TOKEN_REMAINING_TIME.toString();

  async task() {
    await sessionManager.refreshToken.refreshTokenData();
  }
}

/**
 * Main class to manage the cron tasks
 */
export class CronJob {
  public taskCheckRefreshTokenExpiration: TaskCheckRefreshTokenExpiration;
  public taskCheckLiveness: TaskCheckLiveness;
  public taskDisplayAccessTokenRemainingTime: TaskDisplayAccessTokenRemainingTime;
  public taskDisplayRefreshTokenRemainingTime: TaskDisplayRefreshTokenRemainingTime;

  constructor() {
    this.taskCheckRefreshTokenExpiration = new TaskCheckRefreshTokenExpiration();
    this.taskCheckLiveness = new TaskCheckLiveness();
    this.taskDisplayAccessTokenRemainingTime = new TaskDisplayAccessTokenRemainingTime();
    this.taskDisplayRefreshTokenRemainingTime = new TaskDisplayRefreshTokenRemainingTime();
  }

  public stopAll() {
    this.taskCheckRefreshTokenExpiration.stop();
    this.taskCheckLiveness.stop();
    this.taskDisplayAccessTokenRemainingTime.stop();
    this.taskDisplayRefreshTokenRemainingTime.stop();
  }
}
